import { useContext } from 'react';
import { createContext } from 'react';
import { useDisclosureLayout } from '../../DisclosureLayout/hooks/useDisclosureLayout';

import { DisclosureTriggerProps } from '../@types/DisclosureTriggerProps';

export const DisclosureTriggerContext = createContext<DisclosureTriggerProps>({} as DisclosureTriggerProps);

DisclosureTriggerContext.displayName = 'DisclosureTrigger';

const DisclosureTriggerProvider = ({ blockClass, children, as: As }: DisclosureTriggerProps) => {
	const { isOpen, setIsOpen, componentId } = useDisclosureLayout();

	const renderClass = () => {
		return blockClass
			? `trigger--${blockClass} trigger--${blockClass}--${isOpen ? 'visible' : 'hidden'} trigger--${blockClass} vtex-disclosure-layout-1-x-trigger--${blockClass}--${isOpen ? 'visible' : 'hidden'}`
			: ``;
	};
	return (
		<As
			data-selection={componentId}
			onClick={() => setIsOpen(!isOpen)}
			aria-expanded={`${isOpen ? 'true' : 'false'}`}
			className={`trigger  trigger--${isOpen ? 'visible' : 'hidden'} vtex-disclosure-layout-1-x-trigger vtex-disclosure-layout-1-x-trigger--${isOpen ? 'visible' : 'hidden'} ${renderClass()}`}
			role="button"
		>
			{children}
		</As>
	);
};

export const useDisclosureTrigger = () => {
	const context = useContext(DisclosureTriggerContext);

	return context;
};

export default DisclosureTriggerProvider;
